import type { ProductConfig } from '#types/config/components/product'

export default {
  quickshopType: 'quickshop-elevate'
} satisfies ProductConfig['shopTheLook']
